import script from "./StepMethod.vue?vue&type=script&setup=true&lang=js"
export * from "./StepMethod.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import InputField from "@/components/neue/InputField.vue";
import SelectionCard from "@/components/neue/wizard/SelectionCard.vue";
import SelectionGroup from "@/components/neue/wizard/SelectionGroup.vue";
import WizardSection from "@/components/neue/wizard/WizardSection.vue";
script.components = Object.assign({}, { InputField, SelectionCard, SelectionGroup, WizardSection }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { InputField, SelectionCard, SelectionGroup, WizardSection }, script.__o.components);}